import styled from "styled-components";

/*
 * iOS 26 の Safari には、100vh がブラウザUIの変化に追従せずレイアウト・描画が壊れる
 * 既知の不具合がある（スクロール時に内容が描画されない等）。そのため:
 *
 *  - height を固定せず min-height にする。高さを固定すると内容がはみ出したときに
 *    body ではなくこの要素がスクロールコンテナになり、描画事故が起きやすい
 *  - 対応ブラウザでは dvh（実際の可視領域）を使う。未対応なら直前の vh が残る
 *  - overflow-x: hidden は overflow-y を auto 扱いにしてしまい、これもスクロール
 *    コンテナ化の原因になる。clip なら横方向の溢れだけを止められる（未対応環境は hidden のまま）
 */
export const StyledAppLayout = styled.div`
    display: flex;
    min-height: 100vh;
    min-height: 100dvh;
    overflow-x: hidden;
    overflow-x: clip;
`;

export const Sidebar = styled.div<{isOpen: boolean}>`
    width:380px;
    position:fixed;
    transition: left 0.3s ease-in-out;
    z-index: 1100;
    top: 0;
    height: 100vh;
    height: 100dvh;
    @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        width:280px;
        left: ${(p) => (p.isOpen ? "0" : "-350px")};
        box-shadow: 1px -2px 23px 10px rgba(0,0,0,0.25);
        -webkit-box-shadow: 1px -2px 23px 10px rgba(0,0,0,0.25);
        -moz-box-shadow: 1px -2px 23px 10px rgba(0,0,0,0.25);
    }
`;

/*
 * メニューを開いたときの背景オーバーレイ（モバイルのみ）
 * タップでメニューを閉じられるようにする。タブレット以上はメニューが常時表示なので出さない。
 */
export const MenuOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1099;
    background-color: rgba(0, 0, 0, 0.2);
    @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        display: none;
    }
`;

export const MainContent = styled.div`
    position: relative;
    margin-left:380px;
    width: calc(100% - 380px);
    overflow-x: hidden;
    overflow-x: clip;
    @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        margin-left: 0;
        width: 100%;
    }
`;

export const MenuToggleButton = styled.button`
    position: fixed;
    top: 6px;
    right: 15px;
    z-index: 1100;
    color: black;
    border: none;
    padding: 10px;
    font-size: 24px;
    cursor: pointer;
    border-radius: 5px;
    background-color:rgba(0,0,0,0);
    @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        display: none;
    }
`;
